module.exports = __webpack_public_path__ + "assets/d5153ad4-7c93-4757-9147-640e69ec4801.eb1279a4.svg";